import { useEffect, useState } from "react";
import HeroSection from "../../components/hero-section/HeroSection";
import ImageSlider from "../../components/image-slider/ImageSlider";
import IntroSection from "../../components/intro-section/IntroSection";
import WhySection from "../../components/why-section/WhySection";
import HowItWorksSection from "../../components/how-it-works-section/HowItWorksSection";
import ServicePackageSection from "../../components/service-package-section/ServicePackageSection";
import OtherServicesSection from "../../components/other-services-section/OtherServicesSection";

const importAllImages = (r: any): string[] => r.keys().map(r);

declare const require: any;

const Home = () => {
  const [images, setImages] = useState<string[]>([]);

  useEffect(() => {
      const imagesArray = importAllImages(
          require.context('../../assets/work', false, /\.(png|jpe?g|gif)$/)
      );
      setImages(imagesArray);
  }, []);
  return (
    <div className='categories-container'>
      <HeroSection />
      <IntroSection />
      <WhySection />
      <HowItWorksSection />
      <ServicePackageSection />
      <OtherServicesSection />
      <div className='slider-title'>
                <h1>
                    Our Work
                </h1>
            </div>
      <ImageSlider images={images} autoSlideInterval={5000}/>
    </div>
  );
}

export default Home;